'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigateToThreadList = navigateToThreadList;

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

var _clearSelectedThread = require('../../selected-thread/actions/clearSelectedThread');

var _updateView = require('../../current-view/actions/updateView');

var _views = require('../../current-view/constants/views');

var _trackUserInteraction = require('../../actions/trackUserInteraction');

function navigateToThreadList() {
  return function (dispatch) {
    dispatch((0, _trackUserInteraction.trackUserInteraction)());
    dispatch((0, _clearSelectedThread.clearSelectedThread)());

    dispatch((0, _updateView.updateView)(_views.THREAD_LIST));

    dispatch((0, _trackInteraction.trackInteraction)('widget-interaction', {
      action: 'view thread list'
    }));
  };
}